// TODO To document.
export default new class AutoloadViews
{
    load(prefix, files, overrideFiles = null)
    {
        // Get possible override file names.
        let overrideFileNames = [];

        if(overrideFiles)
            overrideFiles.keys().forEach(fileName => overrideFileNames.push(fileName));

        // Loop files.
        files.keys().forEach(fileName =>
        {
            // Determine if has override.
            let hasOverride = overrideFileNames&& overrideFileNames.indexOf(fileName) !== -1;

            // Access file, which means it will be loaded right now via Webpack.
            let fileSrc = hasOverride ? overrideFiles(fileName) : files(fileName);

            // Include override / Galaxy file of Javascript?
            if(fileName.split('.').pop() == 'vue')
                this.initVue(prefix, fileName, fileSrc);
        });
    }

    initVue(prefix, fileName, fileExport)
    {
        // TODO Doc
        // Format prefix?
        if(prefix)
        {
            // Support module::filename syntax, by converting it to module--filename.
            prefix = prefix.split('::').join('--');

            // Dot notation to kebab case.
            prefix = (prefix.split('.').length > 1) ? prefix.split('.').join('-') + '-' : prefix;
        }

        // Build tag by our convention.Vue.component(tag, fileExport.default);
        var formattedFilename = fileName.substr(2).split('.vue')[0].split('/').join('-');
        var tag = (prefix + /*'components-' +*/ formattedFilename).toLowerCase();

        // @debug Enable to see all registered tags.
        // console.info({ tag });

        // Register Vue component? Vue may be not included in website habitat.
        if(window.Vue)
            Vue.component(tag, fileExport.default);
    }

};
